/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, Input } from '@angular/core';
import { RotateElementDirection } from '../models/rotate-element-direction';

@Component({
  selector: 'sysque-rotate-element',
  templateUrl: './rotate-element.component.html',
  styleUrls: ['./rotate-element.component.scss'],
  standalone: false
})
export class RotateElementComponent {
  @Input() emitRotationAction: (rotationValue: number, direction: RotateElementDirection) => void;
  @Input() emitRotationValueChanged: (rotationValue: number) => void;

  public LEFT = RotateElementDirection.Left;
  public RIGHT = RotateElementDirection.Right;
  public rotationValue = 90;

  constructor() {
    this.emitRotationAction = this.emitRotationAction?.bind(this);
    this.emitRotationValueChanged = this.emitRotationValueChanged?.bind(this);
  }

  public updateRotationValue(e: any): void {
    this.rotationValue = e.value;
    this.emitRotationValueChanged(this.rotationValue);
  }

  public emitRotationCommand(direction: RotateElementDirection): void {
    this.emitRotationAction(this.rotationValue, direction);
  }
}
